var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.983,
    height: 12.877,
    viewBox: "0 0 13.983 12.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16402",
    "data-name": "Path 16402",
    d: "M14.616-11.426a2.909,2.909,0,0,1-.932,2l-.1.1L8.156-3.6A33.746,33.746,0,0,1,5.208-.791,3.69,3.69,0,0,1,3.489.2a2.614,2.614,0,0,1-1.31-.5A2.5,2.5,0,0,1,1.169-1.318,8.037,8.037,0,0,1,.8-3.182,25.889,25.889,0,0,1,.633-6.267a2.353,2.353,0,0,1,.756-1.674,2.3,2.3,0,0,1,1.67-.769q.87,0,1.037,1.591.018.185.026.272a7.972,7.972,0,0,0,.325,1.705q.185.483.5.483a1.133,1.133,0,0,0,.492-.286A11.29,11.29,0,0,0,6.3-5.722l5.581-5.528a8.142,8.142,0,0,1,1.257-1.063,1.832,1.832,0,0,1,.94-.36.435.435,0,0,1,.413.22,1.61,1.61,0,0,1,.123.738Z",
    transform: "translate(-0.633 12.674)",
    fill: "#4fbf26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.86b74a71fc097722ad323d44912f82f9.svg";
export { ForwardRef as ReactComponent };